module.exports = __webpack_public_path__ + "img/diag_maintenance.020e55c1.jpg";